
import React from 'react';
import { CheckCircle, Shield, Users, BarChart } from 'lucide-react';

const PortalsFeatures = () => {
  const features = [
    {
      icon: <Users className="h-10 w-10 text-indigo-700" />,
      title: 'Kundenportale',
      description: 'Bieten Sie Ihren Kunden einen zentralen Zugang zu Produkten, Services und Support für eine optimale Customer Experience.',
      benefits: [
        'Self-Service für häufige Kundenaktionen',
        'Bestellhistorie und Statusverfolgung',
        'Individuelle Angebote und Informationen'
      ]
    },
    {
      icon: <Shield className="h-10 w-10 text-indigo-700" />,
      title: 'Partner- & B2B-Portale',
      description: 'Stärken Sie die Zusammenarbeit mit Geschäftspartnern durch gemeinsame Plattformen für Kommunikation und Datenaustausch.',
      benefits: [
        'Gemeinsame Dokumentenbearbeitung',
        'Sichere Datenfreigabe und -austausch',
        'Nahtlose Integration in bestehende Systeme'
      ]
    },
    {
      icon: <BarChart className="h-10 w-10 text-indigo-700" />,
      title: 'Mitarbeiterportale & Intranets',
      description: 'Steigern Sie die interne Effizienz durch zentrale Plattformen für Zusammenarbeit, Prozesse und Wissensmanagement.',
      benefits: [
        'Automatisierte Workflows für Genehmigungen',
        'Zentrales Wissensmanagement',
        'Effiziente interne Kommunikation'
      ]
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Maßgeschneiderte Portallösungen</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Wir entwickeln individuelle Portale, die Ihre Geschäftsprozesse optimieren und die Interaktion mit Kunden, Partnern und Mitarbeitern verbessern.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white p-6 rounded-xl shadow-lg border border-gray-100 hover:shadow-xl transition-shadow duration-300">
              <div className="mb-5">{feature.icon}</div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">{feature.title}</h3>
              <p className="text-gray-600 mb-6">{feature.description}</p>
              <ul className="space-y-2">
                {feature.benefits.map((benefit, i) => (
                  <li key={i} className="flex items-start">
                    <CheckCircle className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" />
                    <span className="text-gray-700">{benefit}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PortalsFeatures;
